// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1g9Bg","checkboxCol":"Table_checkboxCol__2aypC","emailCol":"Table_emailCol__1xZgt","actionCol":"Table_actionCol__RXEqH"};